import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Routes, Route } from 'react-router-dom';
import { setLocalStorage, getLocalStorage, setJSONLocalStorage, getJSONLocalStorage, getToken, setToken } from './functions/app_functions.js';
import ReactGA from 'react-ga4';
import './App.css';
import withRouter from './with_router.js';
import AnalyticsListener from "./AnalyticsListener";
import { trackEvent } from "./utils/analytics";
import Header from './components/header/header.js';
import Footer from './components/footer/footer.js';
import Loading from './components/loading/loading.js';
import Error from './components/banners/error.js';
import Signup from './components/login/signup.js';
import GoogleCallback from './components/login/google_callback.js';
import Login from './components/login/login.js';
import ResetPassword from './components/login/password_reset.js';
import Home from './components/home/home.js';
import Travelers from './components/benefits/travelers.js';
import Creators from './components/benefits/creators.js';
import Hosts from './components/benefits/hosts.js';
import TourismAgencies from './components/benefits/tourismagencies.js';
import Privacy from './components/legal/privacy.js';
import Terms from './components/legal/terms.js';
import Account from './components/account/account.js';
import User from './components/account/user.js';
import Trips from './components/search/search.js';
import Trip from './components/trip/trip.js';
import CreateTrip from './components/tripowner/createtrip.js';
import ActivateEmail from './components/account/activateemail.js';
import MissingPage from './components/error/missingpage.js';
import Logs from './components/admin/logs.js';
import AdminDashboard from './components/admin/admindashboard.js';
import ProductFeedback from './components/contact/productfeedback.js';
import Ambassador from './components/contact/ambassador.js';
import Contact from './components/contact/contactus.js';

ReactGA.initialize('G-TB9NF18KBC');


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Default states
      loading: false,
      loading_functions: [],
      error: false,
      login: false,
      admin_role: false,
      user_id: "",
      user_email: "",
      user_name: "",
      token: "",
      locations: [],
      activity_categories: [],
      trip_categories: [],
      trip_targets: [],
      trip_pricing: [],
      trip_timing: [],
      trip_duration: [],
      trip_collections: [],
      user_badges: [],
      testimonials_data: [
        {
          name: "Maya Thompson",
          role: "Traveler from Seattle, WA",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/maya_thompson.webp",
          type: "traveler",
          quote: "Guidr made planning my Japan trip stupidly easy. The filters for time of year and budget helped me find an itinerary that felt written for me. I will probably never go back to Japan so it was important to me to visit hidden spots that I otherwise wouldn't even know about."
        },
        {
          name: "Arjun Patel",
          role: "Traveler and hobby photographer from Austin, TX",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/arjun_patel.webp",
          type: "traveler",
          quote: "I loved the day-by-day structure and map pins to find nearby restaurants. No doom-scrolling reviews, just a tight plan with restaurants, activities, and sites that ChatGPT would have never told me about."
        },
        {
          name: "Sofía Rossi",
          role: "Traveler from Boston, MA",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/sofia_rossi.webp",
          type: "traveler",
          quote: "We found a family-friendly Rome itinerary that matched our interests and budget: Gelato stops, stroller-friendly routes, and zero stress planning a once in a lifetime trip."
        },
        {
          name: "Lina Chen",
          role: "Travel and food blogger from Lisbon, Portugal",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/line_chen.webp",
          type: "creator",
          quote: "Turning my favorite food crawl into a Guidr itinerary took an hour, and it now earns while I sleep. Plus travelers follow and compliment me on Instagram."
        },
        {
          name: "Diego Álvarez",
          role: "Hiking guide and outdoor influencer from San Francisco, CA",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/diego_alvarez.webp",
          type: "creator",
          quote: "I used to share my routes as a PDF with friends. With Guidr, I can package antire trips with safety notes, GPX links, and backup options in one place and simply share the link to my trips or profile."
        },
        {
          name: "Aisha N’Dour",
          role: "Travel creator and historian from Paris, France",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/aisha_ndour.webp",
          type: "creator",
          quote: "My self-guided walk of my hometown, Marrakech, lives on Guidr. Travelers learn context, vendors are respected, and I answer fewer DMs."
        },
        {
          name: "Daniela Costa",
          role: "General Manager, Andana Hotel (Valle de Guadalupe, Mexico)",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/daniela_costa.webp",
          type: "host",
          quote: "Curating vineyard itineraries in the Valle de Guadalupe on Guidr turned our concierge tips into bookings. Guests arrive with plans that naturally include our restaurant and partners and they express their gratitude through 5-star reviews."
        },
        {
          name: "Marco Santori",
          role: "General Manager, Octant Douro (Porto, Portugal)",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/marco_santori.webp",
          type: "host",
          quote: "Guidr helps us reach travelers planning months ahead. Our 'Douro Valley day trip' itineraries perform like a digital concierge."
        },
        {
          name: "Ben Whitaker",
          role: "Owner, Red Rock RV & Camp (Utah)",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/ben_whitaker.webp",
          type: "host",
          quote: "We published scenic routes with campsite tips and dump-station notes. Travelers come prepared and shoulder-season stays improved."
        },
        {
          name: "Emma Dubois",
          role: "Airbnb Superhost (Strasbourg, France)",
          picture: "https://guidr-media-dev.s3.us-east-1.amazonaws.com/static-files/testimonials/emma_dubois.webp",
          type: "host",
          quote: "My self-guided '72 hours in Strasbourg' itinerary on Guidr cut message back-and-forth in half. Guests love having coffee, viewpoints, and dinner reservations mapped."
        }
      ]
    };

    this.baseUrl = process.env.REACT_APP_API_URL || "https://api.guidr.net";
    this.webUrl = process.env.REACT_APP_WEB_URL || "https://guidr.net";
    this.apiTimeout = process.env.REACT_APP_API_TIMEOUT || 30000;

    // Define class methods
    this.setLogin = this.setLogin.bind(this);
    this.setLogout = this.setLogout.bind(this);
    this.setLogoutTokenExpired = this.setLogoutTokenExpired.bind(this);
    this.logEvent = this.logEvent.bind(this);
    this.setLoading = this.setLoading.bind(this);
    this.unsetLoading = this.unsetLoading.bind(this);
    this.setError = this.setError.bind(this);
    this.unsetError = this.unsetError.bind(this);
    this.goToPage = this.goToPage.bind(this);
    this.loadLocationData = this.loadLocationData.bind(this);
    this.loadLocationCodes = this.loadLocationCodes.bind(this);
    this.checkAuthStatus = this.checkAuthStatus.bind(this);
    this.authCheckInterval = null;
  }


  componentDidMount() {
    /* ReactGA.pageview(window.location.pathname + window.location.search); */
    this.setLoading("app_componentDidMount");
    window.scrollTo(0, 0);

    // Load data from session storage
    var login = getLocalStorage("login") == "true";
    var admin_role = getLocalStorage("admin_role") == "true";
    var user_id = parseInt(getLocalStorage("user_id"));
    var user_email = getLocalStorage("user_email");
    var user_name = getLocalStorage("user_name");
    var token = getToken();
    var locations = getJSONLocalStorage("locations");
    var locationcodes = getJSONLocalStorage("locationcodes");
    var activity_categories = getJSONLocalStorage("activity_categories");
    var trip_categories = getJSONLocalStorage("trip_categories");
    var trip_targets = getJSONLocalStorage("trip_targets");
    var trip_pricing = getJSONLocalStorage("trip_pricing");
    var trip_timing = getJSONLocalStorage("trip_timing");
    var trip_duration = getJSONLocalStorage("trip_duration");
    var trip_collections = getJSONLocalStorage("trip_collections");
    var user_badges = getJSONLocalStorage("user_badges");
    this.setState({
      login: login,
      admin_role: admin_role,
      user_id: user_id,
      user_email: user_email,
      user_name: user_name,
      locations: locations,
      locationcodes: locationcodes,
      activity_categories: activity_categories,
      trip_categories: trip_categories,
      trip_targets: trip_targets,
      trip_pricing: trip_pricing,
      trip_timing: trip_timing,
      trip_duration: trip_duration,
      trip_collections: trip_collections,
      user_badges: user_badges,
      token: token
    });

    // Check login status
    this.checkAuthStatus();

    // Initialize GA
    this.initializeReactGA();
    this.pageview();

    // Load data from server
    if (!locations || locations.length < 1) {
      this.loadLocationData();
    }
    if (!locationcodes || locationcodes.length < 1) {
      this.loadLocationCodes();
    }
    if (!activity_categories || activity_categories.length < 1) {
      this.loadCategoryData();
    }
    this.authCheckInterval = setInterval(this.checkAuthStatus, 1 * 60 * 1000); // Every 5 minutes
    this.unsetLoading("app_componentDidMount");
  }


  componentWillUnmount() {
    // Cleanup interval when component unmounts
    if (this.authCheckInterval) {
      clearInterval(this.authCheckInterval);
    }
  }


  initializeReactGA() {
    if (process.env.NODE_ENV === "production" && process.env.REACT_APP_GA_TRACKING_ID) {
      ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID, {
        gtagOptions: {
          send_page_view: false, // important for SPAs
        },
      });
    }
  }


  pageview() {
    return true;
    if (process.env.NODE_ENV == "production" && process.env.REACT_APP_GA_TRACKING_ID) {
      try {
        ReactGA.pageview(window.location.pathname + window.location.search);
      } catch (err) {
        // console.log(err);
      }
    }
  }


  logEvent(category, action, label = "") {
    // Track event
    trackEvent("other", { category: category, action: action });
    
    return true
    if (process.env.NODE_ENV == "production" && process.env.REACT_APP_GA_TRACKING_ID) {
      ReactGA.event({
        category: category,
        action: action,
        label: label
      });
    }
  }


  setLoading(caller = null) {
    var loading_functions = this.state.loading_functions || [];
    if (caller) {
      loading_functions.push(caller);
    }
    this.setState({
      loading: true,
      loading_functions: loading_functions
    });
  }


  unsetLoading(caller = null, forced = false) {
    var loading_functions = this.state.loading_functions || [];
    if (caller) {
      loading_functions = loading_functions.filter(item => item != caller);
    }
    if (forced) {
      loading_functions = [];
    }
    this.setState({
      loading: false,
      loading_functions: loading_functions
    });
  }


  setError(name, message) {
    var error = {
      name: name,
      message: message
    }
    this.setState({
      error: error
    });
    // Track event
    trackEvent("error", { name: name, message: message });
  }


  unsetError() {
    this.setState({
      error: false,
      loading: false
    });
  }


  setLogin(status, user_id, email, token, redirect, admin_role = false) {
    this.setState({
      login: status,
      admin_role: admin_role,
      user_id: user_id,
      user_email: email,
      user_name: "",
      token: token
    })
    setLocalStorage("login", true);
    setLocalStorage("admin_role", admin_role);
    setLocalStorage("user_id", user_id);
    setLocalStorage("user_email", email);
    setLocalStorage("user_name", "");
    setToken(token);
    // Track event
    trackEvent("user_login", { user_id: user_id });
    // Redirect
    if (redirect) {
      this.goToPage(redirect);
    } else {
      this.goToPage("/account");
    }
  }


  setLogout() {
    var user_id = this.state.user_id
    this.setState({
      login: false,
      admin_role: false,
      user_id: "",
      user_email: "",
      user_name: "",
      token: ""
    })
    setLocalStorage("login", false);
    setLocalStorage("admin_role", false);
    setLocalStorage("user_id", "");
    setLocalStorage("user_name", "");
    setLocalStorage("user_email", "");
    setToken("");
    // Track event
    trackEvent("user_logout", { user_id: user_id, type: "manual" });
    // Redirect
    this.goToPage("/");
  }


  setLogoutTokenExpired(redirect = false) {
    var user_id = this.state.user_id
    this.setState({
      login: false,
      admin_role: false,
      user_id: "",
      user_email: "",
      user_name: "",
      token: ""
    })
    setLocalStorage("login", false);
    setLocalStorage("admin_role", false);
    setLocalStorage("user_id", "");
    setLocalStorage("user_name", "");
    setLocalStorage("user_email", "");
    setToken("");
    // Track event
    trackEvent("user_logout", { user_id: user_id, type: "automatic" });
    // Error message
    var name = "";
    var message = "You have been logged out due to inactivity. Please log in again.";
    this.setError(name, message);
    if (redirect) {
      // Redirect
      this.goToPage('/');
    }
  }


  goToPage(page) {
    const { navigate } = this.props;
    // Navigate to Another Component
    navigate(page);
  }


  async loadLocationData() {
    try {
      // Send request
      var response = await fetch(this.baseUrl + "/getlocationsdata", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getToken()}`
        },
      });
      // Process response
      response = await response.json();
      var data = response.value;
      if (data) {
        // Remove duplicates
        const deduplicated = {};
        for (const country in data) {
          deduplicated[country] = [...new Set(data[country])];
        }
        // Set data to state
        this.setState({
          locations: deduplicated
        });
        setJSONLocalStorage("locations", deduplicated);
      } else {
        // Track error
        var name = "";
        var message = "Could not load location data. Please check the URL and try again.";
        this.setError(name, message);
      }
    } catch (error) {
      // Track error
      var name = "";
      var message = "Could not load location data. Please check the URL and try again.";
      this.setError(name, message);
      // Track event
      this.logEvent("Client error", "App_loadLocationData");
    }
  }


  async loadLocationCodes() {
    try {
      // Send request
      var response = await fetch(this.baseUrl + "/getlocationcodes", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getToken()}`
        },
      });
      // Process response
      response = await response.json();
      var data = response.value;
      if (data) {
        // Set data to state
        this.setState({
          locationcodes: data
        });
        setJSONLocalStorage("locationcodes", data);
      } else {
        // Track error
        var name = "";
        var message = "Could not load location data. Please check the URL and try again.";
        this.setError(name, message);
      }
    } catch (error) {
      // Track error
      var name = "";
      var message = "Could not load location data. Please check the URL and try again.";
      this.setError(name, message);
      // Track event
      this.logEvent("Client error", "App_loadLocationCodes");
    }
  }


  async loadCategoryData() {
    try {
      // Send request
      var response = await fetch(this.baseUrl + "/getcategoriesdata", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getToken()}`
        },
      });
      // Process response
      response = await response.json();
      var data = response.value;
      if (data) {
        // Set data to state
        this.setState({
          activity_categories: data.ActivityCategories,
          trip_categories: data.TripCategories,
          trip_targets: data.TripTargets,
          trip_pricing: data.TripPricing,
          trip_timing: data.TripTiming,
          trip_duration: data.TripDuration,
          trip_collections: data.Collections,
          user_badges: data.Badges
        });
        setJSONLocalStorage("activity_categories", data.ActivityCategories);
        setJSONLocalStorage("trip_categories", data.TripCategories);
        setJSONLocalStorage("trip_targets", data.TripTargets);
        setJSONLocalStorage("trip_pricing", data.TripPricing);
        setJSONLocalStorage("trip_timing", data.TripTiming);
        setJSONLocalStorage("trip_duration", data.TripDuration);
        setJSONLocalStorage("trip_collections", data.Collections);
        setJSONLocalStorage("user_badges", data.Badges);
      } else {
        // Track error
        var name = "";
        var message = "Could not load configuration data. Please check the URL and try again.";
        this.setError(name, message);
      }
    } catch (error) {
      // Track error
      var name = "";
      var message = "Could not load configuration data. Please check the URL and try again.";
      this.setError(name, message);
      // Track event
      this.logEvent("Client error", "App_loadCategoryData");
    }
  }


  async checkAuthStatus() {
    if (this.state.login) {
      try {
        // Send request
        var response = await fetch(this.baseUrl + "/loginrefresh", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getToken()}`
          },
        });
        // Process response
        response = await response.json();
        var data = response.value;
        if (!data) {
          this.setLogout();
          // Track event
          this.logEvent("Client error", "App_checkAuthStatus");
        } else {
          setToken(data.token);
        }
      } catch (error) {
        // Track event
        this.logEvent("Client error", "App_checkAuthStatus");
      }
    }
  }


  render() {
    return (
      <div>

        <Helmet>
          {/* Add the breadcrumb schema as JSON-LD */}
          <script type="application/ld+json">
            {`
              {
                  "@context": "https://schema.org",
                  "@type": "BreadcrumbList",
                  "itemListElement": [
                  {
                      "@type": "ListItem",
                      "position": 1,
                      "name": "Guidr Home",
                      "item": "https://guidr.net/"
                  }
                  ]
              }
            `}
          </script>
          <title>{"Guidr | Discover trip itineraries by travel experts"}</title>
        </Helmet>

        <Header
          login={this.state.login}
          name={this.state.user_name}
          setLogout={this.setLogout}
          location={this.props.location}
        />

        {(this.state.loading || this.state.loading_functions.length >= 1) &&
          <Loading
          />
        }

        {this.state.error &&
          <Error
            error={this.state.error}
            closeError={this.unsetError}
          />
        }

        <AnalyticsListener />

        <Routes>
          <Route
            exact={true}
            path='/login'
            element={
              <Login
                token={this.state.token}
                baseUrl={this.baseUrl}
                apiTimeout={this.apiTimeout}
                login={this.state.login}
                setLogin={this.setLogin}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                location={this.props.location}
              />}
          />


          <Route
            exact={true}
            path='/resetpassword'
            element={
              <ResetPassword
                baseUrl={this.baseUrl}
                apiTimeout={this.apiTimeout}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
              />}
          />


          <Route
            exact={true}
            path='/signup'
            element={
              <Signup
                baseUrl={this.baseUrl}
                apiTimeout={this.apiTimeout}
                setLogin={this.setLogin}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                location={this.props.location}
              />}
          />


          <Route
            exact={true}
            path="/signup/oauth2/callback"
            element={
              <GoogleCallback
                baseUrl={this.baseUrl}
                apiTimeout={this.apiTimeout}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                setLogin={this.setLogin}
              />}
          />


          <Route
            exact={true}
            path='/'
            element={
              <Home
                baseUrl={this.baseUrl}
                apiTimeout={this.apiTimeout}
                locations={this.state.locations}
                locationcodes={this.state.locationcodes}
                logEvent={this.logEvent}
                goToPage={this.goToPage}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                testimonials={this.state.testimonials_data}
              />}
          />


          {<Route
            exact={true}
            path='/travelers'
            element={
              <Travelers
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                testimonials={this.state.testimonials_data.filter(({ type }) => type === 'traveler')}
              />}
          />}


          {<Route
            exact={true}
            path='/creators'
            element={
              <Creators
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                testimonials={this.state.testimonials_data.filter(({ type }) => type === 'creator')}
              />}
          />}


          {<Route
            exact={true}
            path='/hosts'
            element={
              <Hosts
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                testimonials={this.state.testimonials_data.filter(({ type }) => type === 'host')}
              />}
          />}


          {<Route
            exact={true}
            path='/tourismagencies'
            element={
              <TourismAgencies
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                testimonials={this.state.testimonials_data.filter(({ type }) => type === 'host')}
              />}
          />}


          {<Route
            exact={true}
            path='/terms'
            element={
              <Terms
                logEvent={this.logEvent}
                setError={this.setError}
              />}
          />}


          {<Route
            exact={true}
            path='/privacy'
            element={
              <Privacy
                logEvent={this.logEvent}
                setError={this.setError}
              />}
          />}


          <Route
            exact={true}
            path='/feedback'
            element={
              <ProductFeedback
                baseUrl={this.baseUrl}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                goToPage={this.goToPage}
              />}
          />


          <Route
            exact={true}
            path='/ambassador'
            element={
              <Ambassador
                baseUrl={this.baseUrl}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                goToPage={this.goToPage}
              />}
          />


          <Route
            exact={true}
            path='/contact'
            element={
              <Contact
                baseUrl={this.baseUrl}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                goToPage={this.goToPage}
              />}
          />


          <Route
            exact={true}
            path='/u/:userid?'
            element={
              <User
                baseUrl={this.baseUrl}
                token={this.state.token}
                apiTimeout={this.apiTimeout}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                login_user={this.state.login}
              />}
          />


          <Route
            exact={false}
            path='/trips'
            element={
              <Trips
                baseUrl={this.baseUrl}
                apiTimeout={this.apiTimeout}
                locations={this.state.locations}
                trip_categories={this.state.trip_categories}
                trip_targets={this.state.trip_targets}
                trip_pricing={this.state.trip_pricing}
                trip_timing={this.state.trip_timing}
                trip_duration={this.state.trip_duration}
                login={this.state.login}
                user_id={this.state.user_id}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                goToPage={this.goToPage}
              />}
          />


          <Route
            exact={false}
            path='/trip/:tripid?'
            element={
              <Trip
                baseUrl={this.baseUrl}
                webUrl={this.webUrl}
                apiTimeout={this.apiTimeout}
                locations={this.state.locations}
                activity_categories={this.state.activity_categories}
                trip_categories={this.state.trip_categories}
                trip_targets={this.state.trip_targets}
                trip_pricing={this.state.trip_pricing}
                trip_timing={this.state.trip_timing}
                trip_duration={this.state.trip_duration}
                login={this.state.login}
                user_id={this.state.user_id}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                goToPage={this.goToPage}
                setError={this.setError}
                location={this.props.location}
              />}
          />


          <Route
            exact={true}
            path='/activateemail'
            element={
              <ActivateEmail
                baseUrl={this.baseUrl}
                apiTimeout={this.apiTimeout}
                logEvent={this.logEvent}
                setLoading={this.setLoading}
                unsetLoading={this.unsetLoading}
                setError={this.setError}
                goToPage={this.goToPage}
              />}
          />


          {this.state.login &&
            <Route
              exact={true}
              path='/account'
              element={
                <Account
                  baseUrl={this.baseUrl}
                  webUrl={this.webUrl}
                  locations={this.state.locations}
                  login={this.state.login}
                  user_id={this.state.user_id}
                  logEvent={this.logEvent}
                  setLoading={this.setLoading}
                  unsetLoading={this.unsetLoading}
                  goToPage={this.goToPage}
                  setError={this.setError}
                />}
            />
          }


          {!this.state.login &&
            <Route
              exact={true}
              path='/account'
              element={
                <MissingPage />
              }
            />
          }


          {this.state.login &&
            <Route
              exact={true}
              path='/createtrip'
              element={
                <CreateTrip
                  baseUrl={this.baseUrl}
                  apiTimeout={this.apiTimeout}
                  trip_categories={this.state.trip_categories}
                  trip_targets={this.state.trip_targets}
                  trip_pricing={this.state.trip_pricing}
                  trip_timing={this.state.trip_timing}
                  login={this.state.login}
                  user_id={this.state.user_id}
                  logEvent={this.logEvent}
                  setLoading={this.setLoading}
                  unsetLoading={this.unsetLoading}
                  setError={this.setError}
                  goToPage={this.goToPage}
                  setLogoutTokenExpired={this.setLogoutTokenExpired}
                />}
            />
          }


          {!this.state.login &&
            <Route
              exact={true}
              path='/createtrip'
              element={
                <MissingPage />
              }
            />
          }


          {this.state.login && this.state.admin_role &&
            <Route
              exact={true}
              path='/logs'
              element={
                <Logs
                  baseUrl={this.baseUrl}
                  apiTimeout={this.apiTimeout}
                  logEvent={this.logEvent}
                  setLoading={this.setLoading}
                  unsetLoading={this.unsetLoading}
                  setError={this.setError}
                />
              }
            />
          }


          {this.state.login && this.state.admin_role &&
            <Route
              exact={true}
              path='/admindashboard'
              element={
                <AdminDashboard
                  baseUrl={this.baseUrl}
                  apiTimeout={this.apiTimeout}
                  logEvent={this.logEvent}
                  setLoading={this.setLoading}
                  unsetLoading={this.unsetLoading}
                  setError={this.setError}
                  collections={this.state.trip_collections}
                  badges={this.state.user_badges}
                />
              }
            />
          }

        </Routes>


        <Footer
        />

      </div >
    );
  }
}

export default withRouter(App);